import React from 'react';
import PropTypes from "prop-types";
import {Redirect, Switch} from 'react-router-dom';

import Header from 'components/Header';
import Sidenav from 'components/Sidenav';
import Footer from 'components/Footer';
import Account from '../routes/accounts/';

import Dashboard from '../routes/dashboard/';
import Point_Of_Sales from '../routes/point_of_sales/';
import Locations from '../routes/locations/';
import Acquisitions from '../routes/acquisitions/';
import Changes from '../routes/changes/';
import Customers from '../routes/customers/';
import Custom_Exports from '../routes/custom_exports/';
import Davidsons_Products from '../routes/davidsons_products';
import Dealers from '../routes/dealers/';
import Destroys from '../routes/destroys/';
import Dispositions from '../routes/dispositions/';
import Events from '../routes/events/';
import Exports from '../routes/exports/';
import Importers from '../routes/importers';
import Legal_Entities from '../routes/legal_entities/';
import Losses from '../routes/losses/';
import NFA from '../routes/nfa/';
import Products from '../routes/products/';
import Reservations from '../routes/reservations/';
import Rentals from '../routes/rentals/';
import Security from '../routes/security/';
import Users from '../routes/users/';
import Kiosks from '../routes/kiosks/';

import Transfers from '../routes/transfers/';

import Framework from '@beardeddevops/react.framework';
import ErrorBoundaryRoute from '../../../containers/ErrorBoundaryRoute';
import Access from "constants/Access";
import WarningAlert from "../../../components/Elements/DispositionPendingWarningAlert";
import MarketingBanner from "../../../components/Objects/MarketingBanner";
import API from "@beardeddevops/react.api";
import {Types} from "../../../components";
import FirearmTraces from "../routes/firearm_trace/components/FirearmTraces";

export default class MainApp extends React.Component {
	static propTypes = {
		shouldReloadCart: PropTypes.bool,
		scannedCode: PropTypes.object,
	};

	constructor(props) {
		super(props);
		this.state = {
			reloadPage: false,
			hasModalOpen: false,
			marketingActive: false,
			locationDimiss: [],
			headerModals: {
				acquisition: false,
				disposition: false,
				transfer: false,
				loss: false,
				destroy: false,
				rental: false,
				reservation: false,
			}
		};
	}

	componentDidMount() {
		this.reloadShell = this.reloadShell.bind(this);

		const {rootState} = this.props;
		this.rootStateID = rootState.subscribe({
			reloadShell: this.reloadShell,
			handleToggleModal: this.handleToggleModal(this),
			handleReportClose: this.handleReportClose(this)
		});
		if(typeof this.props.rootState.persists_banner !== 'undefined') {
			this.state.dismiss_persists = this.props.rootState.persists_banner.Dismiss;
				const current_date = new Date();
				const marketing_end_date = new Date(this.props.rootState.persists_banner.MarketingEndDate);
				const marketing_start_date = new Date(this.props.rootState.persists_banner.MarketingStartDate);
				if(current_date > marketing_start_date && current_date < marketing_end_date) {
					this.setState({marketingActive: true})
				}
		}

		if (typeof this.props.rootState.location_banner !== 'undefined') {
			this.state.dismiss_location = this.props.rootState.location_banner.Dismiss;
		}

		if (typeof this.props.rootState.locations_about_to_expire !== 'undefined') {
			this.setState({locationsExpired: this.props.rootState.locations_about_to_expire});
		}

	}

	componentWillUnmount() {
		const {rootState} = this.props;
		rootState.unsubscribe(this.rootStateID);
	}

	handleToggleModal = (mainApp) => (e) => {
		const key = e.currentTarget.id;
		// this.state.headerModals = {...this.state.headerModals,[key]:true};
		let newHeaderStates = {
			...mainApp.state.headerModals,
			[key]: true
		};
		mainApp.setState({
			headerModals: newHeaderStates
		});
	}

	handleReportClose = (mainApp) => () => {
		mainApp.setState({
			headerModals: {
				acquisition: false,
				disposition: false,
				transfer: false,
				loss: false,
				destroy: false,
				rental: false,
				reservation: false,
			}
		})
	}
	// ignoreBanner = (banner) => () => {
	// 	//ToggleDissmissOnBAnner needs to run AFTER the state has confirmed changed
	// 	//Otherwise it hits with the wrong data being read in that function
	// 	this.setState({
	// 		[banner]: true
	// 	},this.toggleDismissOnBanner);
	// };


	ignorePersistsBanner = () => {
		this.setState({dismiss_persists: true})
	}

	ignoreDissmissableBanner = () => {
		this.setState({
			dismiss_location: true
		},this.toggleDismissOnBanner);
	}


	ignoreLocationExpirationBanner = async (banner_pkey, ndx) => {

		let locationExpirationModel = new API.BuildClass(Types.Location_Banners._name, 'POST');
		locationExpirationModel.object.pkey = banner_pkey;
		await locationExpirationModel.submit(null, 'POST', true);
		this.setState(prevState => ({
			locationsExpired: prevState.locationsExpired.filter(item => item.pkey !== banner_pkey),
		}));

	}

	toggleDismissOnBanner =  async () => {
		let bannerModel = new API.BuildClass(Types.Location_Banners._name, 'POST');

			bannerModel.object.pkey = this.props.rootState.location_banner.Pkey;
			await bannerModel.submit(null, 'POST');
			this.setState({key: Math.random})

	}

	get hasModalOpen() {
		return this.state.headerModals.acquisition ||
			this.state.headerModals.disposition ||
			this.state.headerModals.transfer ||
			this.state.headerModals.loss ||
			this.state.headerModals.destroy ||
			this.state.headerModals.rental ||
			this.state.headerModals.reservation;
	}

	reloadShell() {
		this.props.rootState.triggerAction('getUserInformation', null);
		this.setState({reloadPage: !this.state.reloadPage});
	}


	 isEmptyObject = (obj) => {
		return JSON.stringify(obj) === '{}'
	}

	render() {
		const {match} = this.props;
		const {name, account, userAccess, locations, states, kiosks, kioskMode, isAdmin, leepUsername, leepPassword, hasInactiveLocationSubscription, locations_about_to_expire} = this.props.rootState;

		if (!account) {
			// Show loading spinner while session is undetermined - component unmounts if not authenticated
			// Prevents dashboard from flashing when unauthenticated users navigate to /
			return <Framework.Elements.LoadingSpinner isLoading={true}/>
		}

		return (
			<div className={"main-app-container" + (kioskMode ? ' kiosk' : '')}>

				{!kioskMode && <Sidenav history={this.props.history} outsideClickIgnoreClass="menu-button" />}

				<section id="page-container" className={"app-page-container" + (kioskMode ? ' no-app-sidebar' : '')}>
					<Header headerModals={this.state.headerModals} scannedCode={this.hasModalOpen ? this.props.scannedCode : null} />

					<div className="app-content-wrapper">
						<div className="app-content">
							<div className="full-height">
								{userAccess <= this.props.rootState.persists_user_access && this.props.rootState.persists_banner !== '' && typeof this.props.rootState.persists_banner !== 'undefined'
									&& !this.state?.dismiss_persists && this.props.rootState.kioskMode === '' && this.props.rootState.persists_banner.IsActive && this.state.marketingActive &&
									<WarningAlert
									onAlertDismiss={this.ignorePersistsBanner}
									warningName={this.props.rootState.persists_banner.MarketingTitle}
									warningMessage={this.props.rootState.persists_banner.MarketingDescription}
									color={this.props.rootState.persists_banner.MarketingBackgroundColor}
									textColor={this.props.rootState.persists_banner.MarketingForegroundColor}
									url={this.props.rootState.persists_banner.MarketingCtaUrl}
									urlText={this.props.rootState.persists_banner.MarketingCtaText}
								/>}

								{userAccess <= this.props.rootState.location_user_access && this.props.rootState.location_banner !== '' && typeof this.props.rootState.location_banner !== 'undefined'
									&& !this.state?.dismiss_location && this.props.rootState.kioskMode === '' && this.props.rootState.location_banner.IsActive &&
									<WarningAlert
										onAlertDismiss={this.ignoreDissmissableBanner}
										warningName={this.props.rootState.location_banner.MarketingTitle}
										warningMessage={this.props.rootState.location_banner.MarketingDescription}
										color={this.props.rootState.location_banner.MarketingBackgroundColor}
										textColor={this.props.rootState.location_banner.MarketingForegroundColor}
										url={this.props.rootState.location_banner.MarketingCtaUrl}
										urlText={this.props.rootState.location_banner.MarketingCtaText}
									/>}

								{/*TODO: make this only show if we get it from the backend*/}
								{hasInactiveLocationSubscription && <div style={{display: 'flex', backgroundColor: 'red', padding: 15, fontSize: 25, justifyContent: 'center', color: 'white'}}>
									Please check your credit card information, one of your subscriptions is past due, and will auto-cancel soon
								</div>}


								{/* Location about to expire code block*/}
								{this?.state?.locationsExpired && this.props.rootState.kioskMode === '' && this?.state?.locationsExpired.map((location, ndx) => {
										return(<WarningAlert
											key={location.pkey}
											onAlertDismiss={() => this.ignoreLocationExpirationBanner(location.pkey, ndx)}
											warningName={location.expiration_message === 'This FFL is expired.' ? 'Location: \'' + location.locations.name + '\' Is Expired' : 'Location: \'' + location.locations.name + '\' About To Expire'}
											warningMessage={location.expiration_message + ' => ' + location.ffl}
										/>)
								})

								}


								{ !this.props.rootState.all_locations_expired  ?
								
								<Switch>


									<ErrorBoundaryRoute path={`${match.url}dashboard`}>
										<Dashboard
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
										/>
									</ErrorBoundaryRoute>

									{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}accounts`}>
										<Account
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>}

									{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}point_of_sales`}>
										<Point_Of_Sales
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>}

									{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}security`}>
										<Security
											account={account}
											locations={locations}
											states={states}
										/>
									</ErrorBoundaryRoute>}

									<ErrorBoundaryRoute path={`${match.url}users`}>
										<Users userAccess={userAccess} />
									</ErrorBoundaryRoute>

									{userAccess <= Access.Manager &&
									<ErrorBoundaryRoute path={`${match.url}kiosks`}>
										<Kiosks
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>}

									{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}acquisitions`}>
										<Acquisitions
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											reloadPage={this.state.reloadPage}
											scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
										/>
									</ErrorBoundaryRoute>}

									<ErrorBoundaryRoute path={`${match.url}dispositions`}>
										<Dispositions
											account={account}
											locations={locations}
											states={states}
											kiosks={kiosks}
											reloadShell={this.reloadShell}
											reloadPage={this.state.reloadPage}
											kioskMode={kioskMode}
											scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
											leepUsername={leepUsername}
											leepPassword={leepPassword}
											userAccess={userAccess}
										/>
									</ErrorBoundaryRoute>

									{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}destroys`}>
										<Destroys
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											reloadPage={this.state.reloadPage}
											scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
										/>
									</ErrorBoundaryRoute>}

									{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}losses`}>
										<Losses
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											reloadPage={this.state.reloadPage}
											scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
										/>
									</ErrorBoundaryRoute>}

									{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}nfa`}>
										<NFA
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>}

									{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}reservations`}>
										<Reservations
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											reloadPage={this.state.reloadPage}
											scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
										/>
									</ErrorBoundaryRoute>}

									{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}rentals`}>
										<Rentals
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											reloadPage={this.state.reloadPage}
											scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
										/>
									</ErrorBoundaryRoute>}

									{userAccess<= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}exports`}>
										<Exports
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>}

									{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}legal_entities`}>
										<Legal_Entities
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>}

									<ErrorBoundaryRoute path={`${match.url}products`}>
										<Products
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
											userAccess={userAccess}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}custom_exports`}>
										<Custom_Exports
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
											userAccess={userAccess}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}davidsons_products`}>
										<Davidsons_Products
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
											userAccess={userAccess}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}customers`}>
										<Customers
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											userAccess={userAccess}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}dealers`}>
										<Dealers
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											userAccess ={userAccess}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}firearm_traces`}>
										<FirearmTraces
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											userAccess={userAccess}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}importers`}>
										<Importers
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											userAccess={userAccess}
											/>
									</ErrorBoundaryRoute>

									{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}transfers`}>
										<Transfers
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											reloadPage={this.state.reloadPage}
											scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
										/>
									</ErrorBoundaryRoute>}

									<ErrorBoundaryRoute path={`${match.url}events`}>
										<Events
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
											userAccess={userAccess}
										/>
									</ErrorBoundaryRoute>

									{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}changes`}>
										<Changes
											account={account}
											locations={locations}
											states={states}
											reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>}

									{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}locations`}>
										<Locations
											account={account}
											locations={locations}
											states={states}
											kioskMode={kioskMode}
											reloadShell={this.reloadShell}
											reloadPage={this.state.reloadPage}
											scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
											userAccess={userAccess}
										/>
									</ErrorBoundaryRoute>}

									<Redirect to="/dashboard"/>
								</Switch> :
									<Switch>
										{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}accounts`}>
											<Account
												account={account}
												locations={locations}
												states={states}
												reloadShell={this.reloadShell}
											/>
										</ErrorBoundaryRoute>}

										{userAccess <= Access.Supervisor && <ErrorBoundaryRoute path={`${match.url}locations`}>
											<Locations
												account={account}
												locations={locations}
												states={states}
												kioskMode={kioskMode}
												reloadShell={this.reloadShell}
												reloadPage={this.state.reloadPage}
												scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
												userAccess={userAccess}
											/>
										</ErrorBoundaryRoute>}

										<ErrorBoundaryRoute path={`${match.url}dashboard`}>
											<Dashboard
												account={account}
												locations={locations}
												states={states}
												reloadShell={this.reloadShell}
												scannedCode={!this.hasModalOpen ? this.props.scannedCode : null}
											/>
										</ErrorBoundaryRoute>

										<Redirect to={userAccess <= Access.Supervisor ? "/accounts#billing" : "/dashboard"}/>
									</Switch>
								}
							</div>
						</div>

						<Footer/>
					</div>
				</section>

			</div>
		);
	}
}

MainApp = Framework.Components.withRootState(MainApp);
